import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import { AutoComplete, Row, Col, Input } from "antd";
import streetsList from "./streets";
import 'antd/dist/antd.css';
import Spin from "antd/es/spin";

const { Option } = AutoComplete;

const AddressInput = ({ onChange }) => {
  const [street, setStreet] = useState('');
  const [house, setHouse] = useState('');
  const [building, setBuilding] = useState('');
  const [porch, setPorch] = useState('');
  const [apartments, setApartments] = useState('');
  const [floor, setFloor] = useState('');
  const [intercomCode, setIntercomCode] = useState('');

  const [loadingStreets, setLoadingStreets] = useState(false);

  const [streets, setStreets] = useState([]);

  const handleSearch = useCallback(_.debounce(value => {
    setLoadingStreets(false);
    if(!value) {
      setStreets([]);
    } else {
      const searchLowerCased = value.toLowerCase();
      setStreets(streetsList.filter(streetName =>
        streetName.toLowerCase().indexOf(searchLowerCased) !== -1
      ));
    }
  }, 700), [setStreet]);

  useEffect(() => {

    const addressValues = [
      {
        value: street,
      },
      {
        value: house,
        prefix: ', д. '
      },
      {
        value: building,
        prefix: 'к'
      },
      {
        value: apartments,
        prefix: ', кв. '
      },
      {
        value: porch,
        prefix: ', под. '
      },
      {
        value: floor,
        prefix: ', эт. '
      },
      {
        value: intercomCode,
        prefix: ', код. '
      },
    ];

    const address = addressValues.reduce(
      (acc, {
        value,
        prefix = '',
      }) =>
        value
          ? [
              ...acc,
              `${prefix}${value}`,
            ]
          : acc,
      [],
    ).join('');

    onChange(address);
  }, [street, house, building, apartments, porch, floor, intercomCode]);

  return (
    <>
      <Row type="flex" gutter={16}>
        <Col span={4}>
          <label htmlFor="">Улица</label>
          <AutoComplete onChange={val => setStreet(val)} onSearch={val => {
            setLoadingStreets(true);
            handleSearch(val);
          }} dataSource={streets}>
            <Input suffix={loadingStreets ? <Spin/> : <span />}/>
          </AutoComplete>
        </Col>
        <Col span={2}>
          <label htmlFor="">Дом</label>
          <Input onChange={e => setHouse(e.target.value)}/>
        </Col>

        <Col span={2}>
          <label htmlFor="">Корпус</label>
          <Input onChange={e => setBuilding(e.target.value)}/>
        </Col>

        <Col span={2}>
          <label htmlFor="">Квартира</label>
          <Input onChange={e => setApartments(e.target.value)}/>
        </Col>

        <Col span={2}>
          <label htmlFor="">Подъезд</label>
          <Input onChange={e => setPorch(e.target.value)}/>
        </Col>
        <Col span={2}>
          <label htmlFor="">Этаж</label>
          <Input onChange={e => setFloor(e.target.value)}/>
        </Col>
        <Col span={4}>
          <label htmlFor="">Код домофона</label>
          <Input onChange={e => setIntercomCode(e.target.value)}/>
        </Col>
      </Row>
    </>
  );

};

export default AddressInput;